module.exports = __webpack_public_path__ + "img/weve_got_your_back.c03c3141.png";